export const CONTENT_SUBMISSION_MODAL_PATH = 'content_submission_modal';
export const CONTENT_SUBMISSION_INITIAL_EXPANDED_STATE_KEY = 'content_submission_initial_expanded_state';